import { Link } from "@mui/material";

export const BatchTableColumns = [
  {
    Header: "Group Id",
    accessor: "batch_id",
    // hideable: false
  },
  {
    Header: "Batch Name",
    accessor: "batch_name",
    Cell: (e) => (
      <Link style={{ color: "blue" }}>
        {e.value}
      </Link>
    ),
  },
  {
    Header: "Teacher Profile Names",
    accessor: "teacherprofilenames",
  },
  {
    Header: "Teacher Profile Counts",
    accessor: "teachercount",
  },
  // {
  //   Header: "Student Profile Names",
  //   accessor: "studentprofilenames",
  // },
  // {
  //   Header: "Student Profile Counts",
  //   accessor: "studentcount",
  // },
];

export const groupTableColumns = [
  
  {
    Header: "Group Name",
    accessor: "batch_name",
    Cell: (e) => (
      <Link style={{ color: "blue" }}>
        {e.value}
      </Link>
    ),
  },
  {
    Header: "Teacher Profile Names",
    accessor: "teacherprofilenames",
  },
  {
    Header: "Teacher Profile Counts",
    accessor: "teachercount",
  },
]